<template>
  <div class="tarjetas-resumen-vencimiento">
    <b-row>
      <b-col xl="12">
        <b-card :header="titulo">
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco" 
                :value="banco" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Tarjeta"
              label-for="tarjetaMarca"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="tarjetaMarca" 
                :value="tarjetaMarca"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nro.Cuenta"
              label-for="numeroCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCuenta" 
                :value="numeroCuenta" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="!noResumen"
              label="Fecha de Cierre"
              label-for="fechaCierre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCierre" 
                :value="fechaCierre | fecha" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="!noResumen"
              label="Fecha de Vencimiento"
              label-for="fechaVencimiento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVencimiento" 
                :value="fechaVencimiento | fecha" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-card header="Listado de Cupones">
      <div class="tarjetas-resumen-vencimiento-plastico" 
          v-for="{ id, titular, numero, cuotas, totalesCuotas } in plasticos" :key="id">
        <div class="header-plastico">
          <h3>Titular: {{ titular }}</h3>
          <h4>Nro. Tarjeta: {{ numero }}</h4>
        </div>

        <b-table hover
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="cuotas" 
            :fields="cuotasFields">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>              
          <template v-slot:cell(fechaCupon)="data">
            {{ data.item.fechaCupon | fecha }}
          </template>
          <template v-slot:cell(loteCupon)="data">
            {{ data.item.loteNumero + ' / ' + data.item.cuponNumero }}
          </template>
          <template v-slot:cell(cuota)="data">
            {{ data.item.numeroCuota + ' / ' + data.item.cuotas }}
          </template>
          <template v-slot:cell(importeCuotaPesos)="data">
            <template v-if="data.item.monedaId == 101">
              {{ data.item.importeCuotaPesos | moneda }}
            </template>
          </template>
          <template v-slot:cell(importeCuotaDolares)="data">
            <template v-if="data.item.monedaId == 102">
              {{ data.item.importeCuotaDolares | moneda('USD') }}
            </template>
          </template>
        </b-table>

        <b-table
            v-if="cuotas.length != 0"
            small 
            responsive="sm"
            class="registro totales" 
            :items="totalesCuotas" 
            :fields="totalesFields">
          <template v-slot:cell(totalPesos)="data">
            {{ data.item.totalPesos | moneda }}
          </template>
          <template v-slot:cell(totalDolares)="data">
            {{ data.item.totalDolares | moneda('USD') }}
          </template>
        </b-table>
      </div>
    </b-card>
    <b-card header="Totales">
      <b-form>
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Total Cupones"
              label-for="totalPlasticosPesos"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="totalPlasticosPesos" 
                :value="totalPlasticosPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Saldo Anterior"
              label-for="saldoAnteriorPesos"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="saldoAnteriorPesos" 
                :value="saldoAnteriorPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <br v-if="cerrado">

            <b-form-group
              v-if="cerrado"
              label="Total Consumos"
              label-for="importeConsumosPesos"
              :label-cols="labelCols * 2"
              description="Consumos + Saldos ($)"
              horizontal>
              <b-form-input 
                id="importeConsumosPesos" 
                :value="importeConsumosPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="cerrado"
              label="Total Gastos"
              label-for="importeGastosPesos"
              :label-cols="labelCols * 2"
              description="Gastos + Impuestos ($)"
              horizontal>
              <b-form-input 
                id="importeGastosPesos" 
                :value="importeGastosPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="cerrado"
              label="Total Resumen"
              label-for="importeTotalPesos"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="importeTotalPesos" 
                :value="importeTotalPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <br v-if="tieneSaldo">
            <br v-if="tieneSaldo">

            <b-form-group
              v-if="tieneSaldo"
              label="Saldo"
              label-for="saldoPendientePesos"
              :label-cols="labelCols * 2"
              description="Saldo a cancelar próximo resumen"
              horizontal>
              <b-form-input 
                id="saldoPendientePesos" 
                :value="saldoPendientePesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="Total Cupones"
              label-for="totalPlasticosDolares"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="totalPlasticosDolares" 
                :value="totalPlasticosDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Saldo Anterior"
              label-for="saldoAnteriorDolares"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="saldoAnteriorDolares" 
                :value="saldoAnteriorDolares | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <br v-if="cerrado">

            <b-form-group
              v-if="cerrado"
              label="Total Consumos"
              label-for="importeConsumosDolares"
              :label-cols="labelCols * 2"
              description="Consumos + Saldos (USD)"
              horizontal>
              <b-form-input 
                id="importeConsumosDolares" 
                :value="importeConsumosDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="cerrado"
              label="Total Gastos"
              label-for="importeGastosDolares"
              :label-cols="labelCols * 2"
              description="Gastos + Impuestos (USD)"
              horizontal>
              <b-form-input 
                id="importeGastosDolares" 
                :value="importeGastosDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="cerrado"
              label="Total Resumen"
              label-for="importeTotalDolares"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="importeTotalDolares" 
                :value="importeTotalDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <br v-if="tieneSaldo">
            <br v-if="tieneSaldo">

            <b-form-group
              v-if="tieneSaldo"
              label="Saldo"
              label-for="saldoPendienteDolares"
              :label-cols="labelCols * 2"
              description="Saldo a cancelar próximo resumen"
              horizontal>
              <b-form-input 
                id="saldoPendienteDolares" 
                :value="saldoPendienteDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumenVencimiento/getField',
  mutationType: 'tarjetaResumenVencimiento/updateField',
});

export default {
  name:'TarjetasResumenesVencimiento',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal 
  ],
  props: {
    noResumen: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      cuotasFields: [
        { key: 'proveedor' },
        { key: 'fechaCupon' },
        { 
          key: 'loteCupon',
          label: 'Lote / Cupón'
        },
        {
          key: 'cuota',
          class: 'text-right'
        },
        {
          key: 'importeCuotaPesos',
          label: 'Importe $',
          class: 'text-right'
        },
        {
          key: 'importeCuotaDolares',
          label: 'Importe USD',
          class: 'text-right'
        }
      ],

      totalesFields: [
        { key: 'col1' },
        { key: 'col2' },
        { key: 'col3' },
        { 
          key: 'titulo',
          class: 'text-right'
        },
        {
          key: 'totalPesos',
          class: 'text-right'
        },
        {
          key: 'totalDolares',
          class: 'text-right'
        }
      ],

      tableBusy: false,
      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'banco',
      'tarjetaMarca',
      'numeroCuenta',
      'fechaCierre',
      'fechaVencimiento',
      'totalPlasticosPesos',
      'totalPlasticosDolares',
      'plasticos',
      'cerrado',
      'saldoAnteriorPesos',
      'saldoAnteriorDolares',
      'importeConsumosPesos',
      'importeGastosPesos',
      'importeTotalPesos',
      'importeConsumosDolares',
      'importeGastosDolares',
      'importeTotalDolares',
      'saldoPendientePesos',
      'saldoPendienteDolares'
    ]),
    titulo() {
      if ((/true/i).test(this.noResumen)) {
        return "Información de la Tarjeta";
      }

      return 'Información del Resumen';
    },
    tieneSaldo() {
      return this.saldoPendientePesos > 0 || this.saldoPendienteDolares > 0;
    }
  },
  created() {
    let params = {
      tarjetaId: 0,
      tarjetaResumenId: 0
    }

    if ((/true/i).test(this.noResumen)) {
      params.tarjetaId = this.$route.params.tarjetaId;
    } else {
      params.tarjetaResumenId = this.$route.params.id;
    }

    this.tableBusy = true;
    this.$store.dispatch('tarjetaResumenVencimiento/getTarjetaResumen', params)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      if ((/true/i).test(this.noResumen)) {
        this.$router.push({ name: 'TarjetasResumenesNoResumen' });
      } else {
        this.$router.push({ name: 'TarjetasResumenes' });
      }
    },  
  },
  watch: {
  }    
}
</script>

<style>
  .tarjetas-resumen-vencimiento-plastico {
    margin-bottom: 40px;
  }
  .tarjetas-resumen-vencimiento-plastico .header-plastico {
    margin-bottom: 20px;
  }
  .tarjetas-resumen-vencimiento-plastico .header-plastico h3 {
    font-size: 13px;
    font-weight: 600;
  }
  .tarjetas-resumen-vencimiento-plastico .header-plastico h4 {
    font-size: 13px;
    font-weight: 400;
  }
  .tarjetas-resumen-vencimiento .registro {
    margin-bottom: 5px;
  }
  .tarjetas-resumen-vencimiento .registro table td {
    padding: 5px 12px;
  }
  .tarjetas-resumen-vencimiento .registro table th,
  .tarjetas-resumen-vencimiento .registro.totales table td {
    border-top: none;
  }
  .tarjetas-resumen-vencimiento .registro table td[aria-colindex="1"] {
    width: 35%;
  }
  .tarjetas-resumen-vencimiento .registro table td[aria-colindex="2"] {
    width: 15%;
  }
  .tarjetas-resumen-vencimiento .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .tarjetas-resumen-vencimiento .registro table td[aria-colindex="4"] {
    width: 10%;
  }
  .tarjetas-resumen-vencimiento .registro table td[aria-colindex="5"] {
    width: 15%;
  }
  .tarjetas-resumen-vencimiento .registro table td[aria-colindex="6"] {
    width: 15%;
  }
  .tarjetas-resumen-vencimiento .registro.totales table thead {
    display: none
  }
  .tarjetas-resumen-vencimiento .registro.totales table tr {
    font-weight: 600;
    padding: 12px;
  }
</style>
